/* @generated */
// prettier-ignore
if (Intl.PluralRules && typeof Intl.PluralRules.__addLocaleData === 'function') {
  Intl.PluralRules.__addLocaleData({
    "data": {
      "pt": {
        "categories": {
          "cardinal": ["one", "other"],
          "ordinal": ["other"]
        },
        "fn": function fn(n, ord) {
          var s = String(n).split('.'),
            i = s[0];
          if (ord) return 'other';
          return i == 0 || i == 1 ? 'one' : 'other';
        }
      }
    },
    "availableLocales": ["pt"]
  });
}